import { Locale } from '@cibli/shared';

import api from './api';

export const getLocales = async (): Promise<Locale[]> => {
  return await api.get<Locale[]>('/locales/enabled');
};

export const getLocaleWakeWordByCode = async (code: string): Promise<Locale> => {
  return await api.get<Locale>(`/locales/${code}/wake-word`);
};

export default {
  getLocales,
  getLocaleWakeWordByCode,
};
